/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loading from "../../../commons/containers/Loading";
import Status404 from "../../../commons/containers/Status404";
import serviceAPI from "../../../services/serviceAPI";
import { TabTitle } from "../../../utils/functions/GeneralFunctions";
import GoBack from "../../components/GoBack/GoBack";
import CardDocs from "../../components/card-docs/card-docs";
import CardLink from "../../components/card-docs/card-link";
import "./services-info-styles.css";
import { compose } from "redux";
import { FormattedMessage, injectIntl } from "react-intl";

const ServiceInfo = (props) => {
  const { intl } = props;
  const pageTitle = intl.formatMessage({
    id: "LABELS.HOME.SERVICES.REQUISICAO_SERVICO.TITLE",
  });
  const systemTitle = intl.formatMessage({ id: "LABELS.COMMONS.NOME_SISTEMA" });
  const clientTitle = intl.formatMessage({ id: "LABELS.COMMONS.NOME_CLIENTE" });
  TabTitle(`${pageTitle} - ${systemTitle} - ${clientTitle}`);

  const [service, SetService] = useState([]);
  const [loading, SetLoading] = useState(true);
  const [erro, SetErro] = useState(false);

  useEffect(() => {
    serviceAPI
      .get(`/servicos/${props.match.params.codigo}`)
      .then(({ data }) => {
        SetService(data);
        SetLoading(false);
      })
      .catch(function (error) {
        if (error) {
          SetLoading(false);
          SetErro(true);
        }
      });
  }, []);

  if (loading) return <Loading />;
  if (erro) return <Status404 />;

  return (
    <React.Fragment>
      {service.titulo === undefined ? (
        SetErro(true)
      ) : (
        <section className="sds-container">
          <GoBack />

          <section
            className="sds-grid-container"
            aria-label="Informações do Serviço"
          >
            <h2 className="sds-titulo-principal">{service.titulo}</h2>

            {service.conteudos.map((item, index) => {
              return (
                <div key={index}>
                  <div className="services-info-sub-titulo">
                    <span>{item.titulo}</span>
                    <p dangerouslySetInnerHTML={{ __html: item.descricao }}></p>
                  </div>
                </div>
              );
            })}

            {service.linksRelacionados.length > 0 && (
              <div className="services-info-sub-titulo">
                <span>
                  <FormattedMessage id="LABELS.COMMONS.SERVICO.LINKS_RELACIONADOS" />
                </span>
              </div>
            )}

            {service.linksRelacionados.length > 0 &&
              service.linksRelacionados.map((item, index) => {
                return (
                  <div key={index}>
                    <div className="services-info-links">
                      <span>{item.deDescricao}</span>
                      <span> - </span>
                      <a
                        href={item.deUrl}
                        target="_blank"
                        rel="noreferrer"
                        aria-label={`Acessar - ${item.deDescricao}`}
                      >
                        {item.deUrl}
                      </a>
                    </div>
                  </div>
                );
              })}

            {service.docs.filter(document => document.tipoDocumento === 'S').length > 0 && (
              <div className="services-info-titulo-docs">
                <span>
                  <FormattedMessage id="LABELS.COMMONS.SERVICO.DOCUMENTOS_NECESSARIOS" />
                </span>
              </div>
            )}
            {service.docs.filter(document => document.tipoDocumento === 'S').length !== 0 && (
              <section
                className="services-info-docs"
                aria-label="Documentos Solicitação"
              >
                <ul>
                  {service.docs.filter(document => document.tipoDocumento === 'S').map((document, index) => {
                    return (
                      <li key={index}>
                        <CardDocs
                          nome={document.nome}
                          codigoGoDoc={document.codigoGoDoc}
                        />
                      </li>
                    );
                  })}
                </ul>
              </section>
            )}

            {service.docs.filter(document => document.tipoDocumento === 'D').length > 0 && (
              <div className="services-info-titulo-docs">
                <span>
                  <FormattedMessage id="LABELS.COMMONS.SERVICO.DOWNLOADS" />
                </span>
              </div>
            )}

            {service.docs.filter(document => document.tipoDocumento === 'D').length !== 0 && (
              <section
                className="services-info-docs"
                aria-label="Documentos para downloads"
              >
                <ul>
                  {service.docs.filter(document => document.tipoDocumento === 'D').map((document, index) => {
                    return (
                      <li key={index}>
                        <CardDocs
                          nome={document.nome}
                          codigoGoDoc={document.codigoGoDoc}
                        />
                      </li>
                    );
                  })}
                </ul>
              </section>
            )}

            {(service.linkDiagramaFluxo || service.documentacaoFluxo) && (
              <>
                <div className="services-info-titulo-docs">
                  <span><FormattedMessage id="LABELS.COMMONS.SERVICO.FLUXO" />:</span>
                </div>
                <section className="services-info-docs" aria-label="Documentação de processo para download">
                  <ul>
                    {service.linkDiagramaFluxo && (
                      <li><CardLink nome={<FormattedMessage id="LABELS.COMMONS.SERVICO.DIAGRAMA" />} link={service.linkDiagramaFluxo} /></li>
                    )}
                    {service.documentacaoFluxo && (
                      <li><CardDocs nome={<FormattedMessage id="LABELS.COMMONS.SERVICO.DOCUMENTACAO" />} codigoGoDoc={service.documentacaoFluxo} /></li>
                    )}
                  </ul>
                </section>
              </>
            )}

            <Link
              to={`/solicitar-servico/${service.codigo}/formulario/${service.cdExternoForm}`}
              className="services-link-solicitar"
              aria-label={`Solicitar ${service.titulo}`}
            >
              <FormattedMessage id="LABELS.COMMONS.SERVICO.SOLICITAR" />
            </Link>
          </section>
        </section>
      )}
    </React.Fragment>
  );
};

export default compose(injectIntl)(ServiceInfo);
